<template>
  <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false" :close-on-press-escape="false">
    <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()" :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
          <el-form-item label="定向 id" prop="targetingId">
          <el-input v-model="dataForm.targetingId" placeholder="定向 id"></el-input>
      </el-form-item>
          <el-form-item label="定向名称，同一帐号下的定向名称不允许重复" prop="targetingName">
          <el-input v-model="dataForm.targetingName" placeholder="定向名称，同一帐号下的定向名称不允许重复"></el-input>
      </el-form-item>
          <el-form-item label="定向详细设置，存放所有定向条件" prop="targeting">
          <el-input v-model="dataForm.targeting" placeholder="定向详细设置，存放所有定向条件"></el-input>
      </el-form-item>
          <el-form-item label="	是否包含不支持定向，true：包含 API 暂不支持读写的定向信息，false：不包含 API 暂不支持读写的定向信息" prop="isIncludeUnsupportedTargeting">
          <el-input v-model="dataForm.isIncludeUnsupportedTargeting" placeholder="	是否包含不支持定向，true：包含 API 暂不支持读写的定向信息，false：不包含 API 暂不支持读写的定向信息"></el-input>
      </el-form-item>
          <el-form-item label="定向描述" prop="description">
          <el-input v-model="dataForm.description" placeholder="定向描述"></el-input>
      </el-form-item>
          <el-form-item label="是否已删除，true：是，false：否" prop="isDeleted">
          <el-input v-model="dataForm.isDeleted" placeholder="是否已删除，true：是，false：否"></el-input>
      </el-form-item>
          <el-form-item label="创建时间（时间戳）" prop="createdTime">
          <el-input v-model="dataForm.createdTime" placeholder="创建时间（时间戳）"></el-input>
      </el-form-item>
          <el-form-item label="最后修改时间（时间戳）" prop="lastModifiedTime">
          <el-input v-model="dataForm.lastModifiedTime" placeholder="最后修改时间（时间戳）"></el-input>
      </el-form-item>
          <el-form-item label="已选择定向条件的描述" prop="targetingTranslation">
          <el-input v-model="dataForm.targetingTranslation" placeholder="已选择定向条件的描述"></el-input>
      </el-form-item>
          <el-form-item label="	定向包来源，自建或者来自分享，[枚举详情]
默认值：自建" prop="targetingSourceType">
          <el-input v-model="dataForm.targetingSourceType" placeholder="	定向包来源，自建或者来自分享，[枚举详情]
默认值：自建"></el-input>
      </el-form-item>
          <el-form-item label="分享的源账户 id
默认值：分享的源账户 id" prop="shareFromAccountId">
          <el-input v-model="dataForm.shareFromAccountId" placeholder="分享的源账户 id
默认值：分享的源账户 id"></el-input>
      </el-form-item>
          </el-form>
    <template slot="footer">
      <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
      <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
    </template>
  </el-dialog>
</template>

<script>
import debounce from 'lodash/debounce'
export default {
  data () {
    return {
      visible: false,
      dataForm: {
        id: '',
        targetingId: '',
        targetingName: '',
        targeting: '',
        isIncludeUnsupportedTargeting: '',
        description: '',
        isDeleted: '',
        createdTime: '',
        lastModifiedTime: '',
        targetingTranslation: '',
        targetingSourceType: '',
        shareFromAccountId: '',
        createDate: '',
        creator: ''
      }
    }
  },
  computed: {
    dataRule () {
      return {
        targetingId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        targetingName: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        targeting: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        isIncludeUnsupportedTargeting: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        description: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        isDeleted: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        createdTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        lastModifiedTime: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        targetingTranslation: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        targetingSourceType: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
        shareFromAccountId: [
          { required: true, message: this.$t('validate.required'), trigger: 'blur' }
        ],
      }
    }
  },
  methods: {
    init () {
      this.visible = true
      this.$nextTick(() => {
        this.$refs['dataForm'].resetFields()
        if (this.dataForm.id) {
          this.getInfo()
        }
      })
    },
    // 获取信息
    getInfo () {
      this.$http.get(`/sys/tencenttargetings/${this.dataForm.id}`).then(({ data: res }) => {
        if (res.code !== 0) {
          return this.$message.error(res.msg)
        }
        this.dataForm = {
          ...this.dataForm,
          ...res.data
        }
      }).catch(() => {})
    },
    // 表单提交
    dataFormSubmitHandle: debounce(function () {
      this.$refs['dataForm'].validate((valid) => {
        if (!valid) {
          return false
        }
        this.$http[!this.dataForm.id ? 'post' : 'put']('/sys/tencenttargetings/', this.dataForm).then(({ data: res }) => {
          if (res.code !== 0) {
            return this.$message.error(res.msg)
          }
          this.$message({
            message: this.$t('prompt.success'),
            type: 'success',
            duration: 500,
            onClose: () => {
              this.visible = false
              this.$emit('refreshDataList')
            }
          })
        }).catch(() => {})
      })
    }, 1000, { 'leading': true, 'trailing': false })
  }
}
</script>
